import register from '../../../../global/js/registry';
export default register('m-formstep-system-component', () => import(/* webpackMode: "lazy" */ './m-formstep-system-component.controller'));
